
import React, { useEffect, useState } from "react";
import NewsModal from "./NewsModal";
import "./news.css"

const API_URL = process.env.REACT_APP_URL_API;
export default function NewsCard ()  {
  const [news, setNews] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/news/allNews?published=true`)
      .then((res) => res.json())
      .then((data) => {
        if(Array.isArray(data)){
            setNews(data);
        }else{
            console.error("la respuesta no es un array", data);
            setNews([]);
        }
      })
      .catch((err) => console.error("Error cargando noticias:", err));
     
  }, []);

  return (
    <section className="news-section">
      <h2 className="news-title">Lo Último</h2>
      <div className="news-grid">
        {news.map((item) => (
          <div 
          key={item.id} 
          className="news-card" 
          onClick={() => setSelectedNews(item)}
          >
            <div className="news-image-container">
                 <img src={item.image} alt={item.title} className="news-image" />
                 <div className="news-overlay">
                    <h3 className="news-card-title">{item.title}</h3>
                    <span className="news-arrow">→</span>
                 </div>

            </div>             
          </div>
        ))}
      </div>
      <NewsModal news={selectedNews} onClose={()=>setSelectedNews(null)}/>

    </section>
  );
};


